export default __webpack_public_path__ + "static/media/white-green-tick.ae6180f5.svg";